// Numeric boardId → MLS source key
const BOARD_ID_NUM_MAP = {
  175: 'BeachesMLS',
};

// mlsNumber leading-letter prefix → MLS source key
// Prefixes observed in this feed: B, R, RX, F, RD, RE (all BeachesMLS)
const PREFIX_MAP = {
  // BeachesMLS (Southeast Florida: Broward, Palm Beach, St Lucie, Martin, Indian River)
  B: 'BeachesMLS',
  R: 'BeachesMLS',
  RX: 'BeachesMLS',
  F: 'BeachesMLS',
  RD: 'BeachesMLS',
  RE: 'BeachesMLS',
  // Miami MLS / MiamiRealtors — not yet in feed but mapped for future data
  A: 'MiamiMLS',
  MIA: 'MiamiMLS',
  // Stellar MLS (Central FL) — not yet in feed but mapped for future data
  O: 'StellarMLS', T: 'StellarMLS', S: 'StellarMLS', G: 'StellarMLS',
  U: 'StellarMLS', V: 'StellarMLS', W: 'StellarMLS', N: 'StellarMLS',
  C: 'StellarMLS', D: 'StellarMLS', P: 'StellarMLS', L: 'StellarMLS',
  TB: 'StellarMLS',
};

const SOURCE_META = {
  BeachesMLS: {
    key: 'BeachesMLS',
    name: 'BeachesMLS',
    short: 'BeachesMLS',
    // teal/sky accent
    color: '#0ea5e9',
    bg: '#f0f9ff',
    text: '#0369a1',
  },
  MiamiMLS: {
    key: 'MiamiMLS',
    name: 'Miami MLS (MiamiRealtors)',
    short: 'MiamiMLS',
    // orange accent
    color: '#FF9500',
    bg: '#fff7ed',
    text: '#c2410c',
  },
  StellarMLS: {
    key: 'StellarMLS',
    name: 'Stellar MLS',
    short: 'Stellar MLS',
    // indigo accent
    color: '#6366f1',
    bg: '#eef2ff',
    text: '#4338ca',
  },
};

const GENERIC = {
  key: 'mls',
  name: 'MLS',
  short: 'MLS',
  color: '#94a3b8',
  bg: '#f8fafc',
  text: '#64748b',
};

/**
 * Returns { key, name, short, color, bg, text } or null.
 * Resolution order:
 *   1. Numeric boardId (listing.source is the normalized boardId from api.js)
 *   2. String boardId
 *   3. mlsNumber prefix (longest-match first)
 *   4. Generic { key:'mls' } if mlsNumber exists but prefix unknown
 *   5. null if no mlsNumber
 */
export function getMlsSource(listing) {
  if (!listing) return null;

  const boardId = listing.source ?? listing.boardId;
  if (boardId != null && boardId !== '') {
    const numKey = BOARD_ID_NUM_MAP[Number(boardId)];
    if (numKey && SOURCE_META[numKey]) return SOURCE_META[numKey];
    // string lookup
    const strKey = BOARD_ID_NUM_MAP[boardId] || BOARD_ID_NUM_MAP[String(boardId).toUpperCase()];
    if (strKey && SOURCE_META[strKey]) return SOURCE_META[strKey];
  }

  const mls = listing.mlsNumber;
  if (!mls) return null;

  const prefix = mls.match(/^([A-Za-z]+)/)?.[1]?.toUpperCase() ?? '';
  // longest match first (e.g. RX before R)
  const sorted = Object.keys(PREFIX_MAP).sort((a, b) => b.length - a.length);
  for (const p of sorted) {
    if (prefix.startsWith(p)) {
      const srcKey = PREFIX_MAP[p];
      if (SOURCE_META[srcKey]) return SOURCE_META[srcKey];
    }
  }

  return { ...GENERIC };
}
